const Mock = require('mockjs')

const init = () => {
  const requireAll = ctx =>
    ctx
      .keys()
      .forEach(c => {
        const {
          path,
          method,
          mock
        } = ctx(c).default
        Mock.mock(path, method, mock)
      })

  requireAll(require.context('./modules', false, /\.mock\.js$/))

  Mock.setup({
    timeout: '200-1000'
  })
}

export default init
